import { render, staticRenderFns } from "./project_cell.vue.js?vue&type=template&id=0acf7652&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_cell.vue?vue&type=template&id=0acf7652&vue3"
import script from "./project_cell.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_cell.vue?vue&type=script&lang=js&vue3"
export * from "./project_cell.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_cell.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports